export default __webpack_public_path__ + "static/media/subscription-service-icons-12.4856f462.png";